<template>
  <Section v-if="content">
    <Container>
      <FadeIn>
        <div class="md:text-center mx-auto max-w-2xl">
          <div class="mb-2 md:mb-4" v-if="content.pretitle">
            <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
              {{ content.pretitle }}
            </span>
          </div>
          <h2 class="text-section-title" v-if="content.title">{{ content.title }}</h2>
          <p class="text-subtitle" v-if="content.subtitle">{{ content.subtitle }}</p>
        </div>

        <div
        v-if="content.embed"
        class="max-w-[1080px] mx-auto rounded-[20px] md:rounded-[35px] overflow-hidden"
        :class="content.title || content.subtitle ? 'mt-8 lg:mt-16' : 'mt-0'"
        v-html="content.embed"
        ></div>
  
        <div 
        v-else
        class="max-w-[1080px] mx-auto rounded-[20px] md:rounded-[35px] overflow-hidden"
        :class="content.title || content.subtitle ? 'mt-8 lg:mt-16' : 'mt-0'"
        >
          <VideoPlayer
            thumbnail="https://cdn.elker.com/meet-elker/thumbnail_bba26ec6.jpg"
            :videoSources="[
              { quality: '1080p', url: 'https://cdn.elker.com/meet-elker/play_1080p.mp4' },
              { quality: '720p', url: 'https://cdn.elker.com/meet-elker/play_720p.mp4' },
              { quality: '480p', url: 'https://cdn.elker.com/meet-elker/play_480p.mp4' }
            ]"
            captions="https://cdn.elker.com/meet-elker/captions/en.vtt"
          />
        </div>

      </FadeIn>

    </Container>
  </Section>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  }
})
</script>